import { TopToolbar } from "react-admin";
import CounselorsAdd from "../counselors/CounselorsAdd";
import EmployerAdd from "../employers/EmployerAdd";
import CustomExportButton from "../unit/CustomExportButton";
import VendorsAdd from "../vendors/VendorsAdd";
import CustomFilterButton from "../unit/CustomFilterButton";
const PartnersListActions = ({ ...props }) => {
  const selected = props.selected;
  return (
    <>
      <TopToolbar sx={{ width: "100%" }}>
        {/* <CustomFilterButton /> */}
        {selected == "employers" && (
          <>
            <CustomFilterButton />
            <EmployerAdd />
          </>
        )}
        {selected == "vendors" && (
          <>
            <CustomFilterButton />
            <VendorsAdd productList={props.productList} />
          </>
        )}
        {selected == "counselors" && (
          <>
            <CustomFilterButton />
            <CounselorsAdd
              productList={props?.productList}
              counselorList={props?.counselorList}
            />
          </>
        )}
        <CustomExportButton />
      </TopToolbar>
    </>
  );
};

export default PartnersListActions;
